import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface UniversityLogoProps {
  size?: number;
  sx?: SxProps<Theme>;
}

const UniversityLogo: React.FC<UniversityLogoProps> = ({ size = 200, sx }) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        position: 'relative',
        ...sx,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer Yellow Border */}
        <circle
          cx="100"
          cy="100"
          r="98"
          fill="none"
          stroke="#FFC107"
          strokeWidth="4"
        />
        
        {/* Dark Red Ring */}
        <circle
          cx="100"
          cy="100"
          r="90"
          fill="none"
          stroke="#8B0000"
          strokeWidth="2"
        />
        
        {/* Sky Background */}
        <circle
          cx="100"
          cy="100"
          r="85"
          fill="#E3F2FD"
        />
        
        {/* Mountains */}
        <path
          d="M 20 120 Q 40 100, 60 110 T 100 105 T 140 110 T 180 120 L 180 185 L 20 185 Z"
          fill="#8B4513"
        />
        
        {/* Sun */}
        <circle
          cx="100"
          cy="70"
          r="15"
          fill="#FFC107"
        />
        <path
          d="M 100 50 L 100 40 M 100 100 L 100 90 M 70 70 L 60 70 M 130 70 L 140 70 M 78.5 51.5 L 72.5 45.5 M 121.5 51.5 L 127.5 45.5 M 78.5 88.5 L 72.5 94.5 M 121.5 88.5 L 127.5 94.5"
          stroke="#FFC107"
          strokeWidth="2"
        />
        
        {/* Minaret/Tower */}
        <rect
          x="30"
          y="120"
          width="8"
          height="50"
          fill="#8B4513"
        />
        <rect
          x="28"
          y="120"
          width="12"
          height="5"
          fill="#654321"
        />
        
        {/* Open Book */}
        <rect
          x="85"
          y="130"
          width="30"
          height="20"
          fill="#FFFFFF"
          stroke="#8B0000"
          strokeWidth="1"
        />
        <line
          x1="100"
          y1="130"
          x2="100"
          y2="150"
          stroke="#8B0000"
          strokeWidth="0.5"
        />
        <line
          x1="90"
          y1="135"
          x2="95"
          y2="135"
          stroke="#8B0000"
          strokeWidth="0.5"
        />
        <line
          x1="90"
          y1="140"
          x2="95"
          y2="140"
          stroke="#8B0000"
          strokeWidth="0.5"
        />
        <line
          x1="105"
          y1="135"
          x2="110"
          y2="135"
          stroke="#8B0000"
          strokeWidth="0.5"
        />
        <line
          x1="105"
          y1="140"
          x2="110"
          y2="140"
          stroke="#8B0000"
          strokeWidth="0.5"
        />
        
        {/* Buildings */}
        <rect
          x="140"
          y="120"
          width="15"
          height="40"
          fill="#8B4513"
        />
        <rect
          x="160"
          y="125"
          width="12"
          height="35"
          fill="#8B4513"
        />
        
        {/* Arabic/Kurdish Text - Top */}
        <text
          x="100"
          y="25"
          textAnchor="middle"
          fontSize="10"
          fill="#8B0000"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          زانكوى سه لاحه دين
        </text>
        
        {/* Banner at Bottom */}
        <rect
          x="30"
          y="160"
          width="140"
          height="15"
          fill="#8B0000"
        />
        <text
          x="50"
          y="171"
          fontSize="8"
          fill="#FFFFFF"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          ERBIL
        </text>
        <text
          x="100"
          y="171"
          textAnchor="middle"
          fontSize="8"
          fill="#FFFFFF"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          هه ولير
        </text>
        <text
          x="150"
          y="171"
          fontSize="8"
          fill="#FFFFFF"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          1981
        </text>
        
        {/* Outer Ring Text - Left */}
        <text
          x="20"
          y="100"
          fontSize="9"
          fill="#FFFFFF"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
          transform="rotate(-90 20 100)"
        >
          SALAHADDIN
        </text>
        
        {/* Outer Ring Text - Right */}
        <text
          x="180"
          y="100"
          fontSize="9"
          fill="#FFFFFF"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
          transform="rotate(90 180 100)"
        >
          UNIVERSITY
        </text>
        
        {/* Decorative Elements - Wheat */}
        <path
          d="M 15 50 Q 15 60, 15 70 Q 15 80, 18 85"
          stroke="#FFC107"
          strokeWidth="2"
          fill="none"
        />
        <circle cx="15" cy="50" r="2" fill="#FFC107" />
        <circle cx="15" cy="60" r="1.5" fill="#FFC107" />
        <circle cx="15" cy="70" r="1.5" fill="#FFC107" />
        
        {/* Decorative Elements - Flower */}
        <circle cx="185" cy="50" r="4" fill="#FFC107" />
        <circle cx="183" cy="48" r="2" fill="#FFC107" />
        <circle cx="187" cy="48" r="2" fill="#FFC107" />
        <circle cx="185" cy="46" r="2" fill="#FFC107" />
        <circle cx="185" cy="52" r="2" fill="#FFC107" />
      </svg>
    </Box>
  );
};

export default UniversityLogo;

